<template>
  <v-card style="height: 200%" class="rounded-lg">
    <v-card-title
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 31px;
        font-weight: bold;
        color: #05523e;
        padding-top: 30px;
      "
    >
      Add Employee
    </v-card-title>
    <div style="margin: 10px 8% auto">
      <div class="rows">
        <span
          >ID
          <p style="color: red; font-size: 15px">{{ this.dupId }}</p></span
        >
        <v-text-field
          class="textField"
          v-model="Id"
          outlined
          @input="idDuplicateCheck"
          :rules="[rules.required, rules.min, rules.id]"
        />
      </div>
      <div class="rows">
        <span>Password</span>
        <v-text-field
          class="textField"
          v-model="password"
          outlined
          :rules="[rules.min, rules.required]"
          :type="'password'"
        />
      </div>
      <div class="rows">
        <span>Re-Password</span>
        <v-text-field
          class="textField"
          v-model="rePassword"
          outlined
          :rules="[rules.pwMatch, rules.required]"
          :type="'password'"
        />
      </div>
      <div class="rows">
        <span
          >Email
          <p style="color: red; font-size: 15px">{{ this.dupEmail }}</p></span
        >
        <v-text-field
          class="textField"
          v-model="email"
          :rules="[rules.required, rules.emailMatch]"
          outlined
          @input="emailDuplicateCheck"
        />
      </div>
      <div class="rows">
        <span>Cashier Id</span>
        <v-text-field
          class="textField"
          v-model="cashierId"
          :rules="[rules.required]"
          outlined
        />
      </div>
      <div class="rows">
        <span>Permission</span>
        <v-select
          :items="items"
          item-text="label"
          item-value="value"
          class="textField"
          dense
          v-model="permission"
        ></v-select>
      </div>
    </div>
    <v-card-actions style="justify-content: center">
      <v-btn
        class="action elevation-5"
        color="#ffffff"
        style="
          color: #05523e;
          max-width: 120px;
          min-width: 100px;
          font-size: 15px;
          font-weight: bold;
          height: 35px;
          margin: 12px;
        "
        @click="closeModal"
        >Cancle</v-btn
      >
      <v-btn
        class="action white--text elevation-5"
        color="#05523E"
        style="
          max-width: 120px;
          min-width: 100px;
          font-size: 15px;
          font-weight: bold;
          height: 35px;
          margin: 12px;
        "
        @click="validation"
        >Add</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { runGqlMutation } from "@/graphql/gqlUtil.js";
import { CREATEADMIN } from "@/graphql/AccountMutations.js";

export default {
  data() {
    return {
      show1: false,
      Id: "",
      password: "",
      rePassword: "",
      email: "",
      cashierId: "",
      dupId: "",
      permission: 0,
      dupEmail: "",
      items: [
        { label: "Employee", value: 0 },
        { label: "Admin", value: 1 },
      ],
      rules: {
        required: (value) => !!value || "Required.",
        id: (v) =>
          !v || /^[a-zA-Z0-9]*$/.test(v) || "ID must be in English and numbers",
        min: (v) => v.length >= 6 || "Min 6 characters",
        pwMatch: () =>
          this.password == this.rePassword || "Passwords do not match",
        emailMatch: (v) =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      },
    };
  },
  methods: {
    async idDuplicateCheck() {
      try {
        if (
          await this.$store.dispatch("account/getAdminIdForDuplicate", {
            Column: "ID",
            Search: this.Id,
          })
        ) {
          this.dupId = "Duplicate Id";
          return true;
        } else {
          this.dupId = "";
          return false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async emailDuplicateCheck() {
      try {
        if (
          await this.$store.dispatch("account/getAdminEmailForDuplicate", {
            Column: "Email",
            Search: this.email,
          })
        ) {
          this.dupEmail = "Duplicate Email";
          return true;
        } else {
          this.dupEmail = "";
          return false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async validation() {
      try {
        const idCheck = await this.idDuplicateCheck();
        const pwCheck = await this.emailDuplicateCheck();

        if (idCheck || pwCheck) {
          return;
        }
        if (this.Id.legnth < 6 || !/^[a-zA-Z0-9]*$/.test(this.Id)) {
          return;
        } else if (
          this.password.length < 6 ||
          this.rePassword.length < 6 ||
          this.password != this.rePassword
        ) {
          return;
        } else if (
          !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)
        ) {
          return;
        }

        this.addAdmin();
      } catch (err) {
        console.error(err);
      }
    },
    async addAdmin() {
      try {
        const req = {
          ID: this.Id,
          Email: this.email,
          PW: this.password,
          Cashier_ID: this.cashierId,
          Permission: this.permission,
        };

        const updateResult = await runGqlMutation(CREATEADMIN, req);

        if (
          updateResult.message === undefined &&
          updateResult.createAdmin.ResultCount !== 0
        ) {
          await this.$emit("getEmployeeList");
          this.$store.commit("common/snackOn", {
            text: "Add Employee Success!",
          });
          this.closeModal();
        } else {
          this.$store.commit("common/snackErrOn", {
            text: "Add Employee Failed!",
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async closeModal() {
      this.$store.commit("common/changeAddEmployeeModalView");
    },
  },
};
</script>

<style lang="scss">
.rows {
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  height: 65px;
  width: 100%;
}
.rows > span {
  width: 185px;
  font-size: 19px;
  font-weight: 500;
}
.textField {
  max-width: 190px;
  min-width: 190px;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  align-items: stretch !important;
  min-height: 0 !important;
}
</style>
